import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource, MatPaginator, MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material';
import { Title } from '@angular/platform-browser';
import { LoadingService } from 'src/app/_services/loading.service';
import { NotificationService } from 'src/app/_services/notification.service';
import { DialogService } from 'src/app/_services/dialog.service';
import { BannarService } from '../../_ecomservices/bannar.service';

@Component({
  selector: 'app-bannars',
  templateUrl: './bannars.component.html',
  styleUrls: ['./bannars.component.css']
})
export class BannarsComponent implements OnInit {

  bannarList: any = [];
  displayedColumns: string[] = ['Image', 'Name', 'ImageType', 'PageName', 'Action'];

  dataSource: MatTableDataSource<any>;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  searchKey: string;

  constructor(
    private titleService: Title,
    private dialogService: DialogService,
    private loading: LoadingService,
    private bannarService: BannarService,
    private notificationService: NotificationService,
    private dialog: MatDialog,
  ) {
  }

  ngOnInit() {
    this.titleService.setTitle('Bannar List');
    this.onLoadImages();
  }

  onLoadImages() {
    var result = this.bannarService.get_bannars().subscribe(data => {
      //console.log(data);
      this.bannarList = data['data'];
      //console.log(this.bannarList);
      this.dataSource = new MatTableDataSource<any>(data['data']);
      //console.log(this.dataSource);
      this.dataSource.paginator = this.paginator;
      this.loading.spin$.next(false);
    });
  }

  applyFilter() {
    this.dataSource.filter = this.searchKey.trim().toLocaleLowerCase();
  }

  onSearchClear() {
    this.searchKey = "";
    this.applyFilter();
  }


  onCreate() {
    const matDialogConfig = new MatDialogConfig();
    matDialogConfig.disableClose = true;
    matDialogConfig.autoFocus = true;
    matDialogConfig.width = "40%";
    matDialogConfig.position = { top: '0px' };
    this.dialog.open(ImageCreateComponent, matDialogConfig).afterClosed().subscribe(res => {
      this.onLoadImages();
    });
  }

  onEdit(rowData) {
    this.bannarService.populateForm(rowData);
    const matDialogConfig = new MatDialogConfig();
    matDialogConfig.disableClose = true;
    matDialogConfig.autoFocus = true;
    matDialogConfig.width = "40%";
    matDialogConfig.position = { top: '0px' };
    this.dialog.open(ImageCreateComponent, matDialogConfig).afterClosed().subscribe(res => {
      this.onLoadImages();
    });
  }

  onDelete(bannarId) {
    this.dialogService.openConfirmDialog('Are you sure want to delete this image?')
      .afterClosed().subscribe(res => {
        if (res) {
          this.loading.spin$.next(true);
          this.bannarService.delete_bannar(bannarId).subscribe(data => {
            if (data['status']) {
              this.notificationService.success(data['message']);
              this.onLoadImages();
              this.loading.spin$.next(false);
            }
            else {
              this.notificationService.error(data['message']);
              this.loading.spin$.next(false);
            }
          });
        }
      });
  }

}






/* Create Image */
@Component({
  selector: 'create-image-dialog',
  templateUrl: 'create-image-dialog.html',
  styleUrls: ['./bannars.component.css']
})
export class ImageCreateComponent {

  bannar_img: File = null;

  constructor(
    private dialogRef: MatDialogRef<ImageCreateComponent>,
    public bannarService: BannarService,
    private loading: LoadingService,
    private notificationService: NotificationService,
  ) {
  }

  onSelectBannarImageFile(event: any): void {
    const file = event.target.files[0];
    if (file) {
      this.bannar_img = file;
      const reader = new FileReader();
      reader.onload = () => {
        this.bannarService.bannarImagePreview = reader.result;
      };
      reader.readAsDataURL(file);
    }
  }

  onFileChange($event) { }


  onImageFormSubmit(formData: any) {
    if (this.bannarService.bannar_form.valid) {
      this.loading.spin$.next(true);
      if (!this.bannarService.bannar_form.controls['id'].value) {
        // Insert Data
        this.bannarService.insert_bannar(formData, this.bannar_img).subscribe(data => {
          //console.log(data);
          if (data['status']) {
            this.notificationService.success(data['message']);
            this.bannarService.bannar_form.reset();
            this.onClose();
            this.loading.spin$.next(false);
          }
          else {
            this.notificationService.error('Bannar could not be created, Try Again!');
            this.loading.spin$.next(false);
          }
        });
      }
      else {
        // Update Data
        //console.log('data updated');
        this.bannarService.update_bannar(formData, this.bannar_img).subscribe(data => {
          console.log(data);
          if (data['status']) {
            this.notificationService.success(data['message']);
            this.bannarService.bannar_form.reset();
            this.onClose();
            this.loading.spin$.next(false);
          }
          else {
            console.log('error');
            this.notificationService.error(data['message']);
            this.loading.spin$.next(false);
          }
        });
      }
    }
  }


  onClose() {
    // console.log('Close');
    this.bannarService.bannar_form.reset();
    this.dialogRef.close();
  }

}










